import { render, staticRenderFns } from "./MapWrapper.vue?vue&type=template&id=b473ceac"
import script from "./MapWrapper.vue?vue&type=script&lang=js"
export * from "./MapWrapper.vue?vue&type=script&lang=js"
import style0 from "./MapWrapper.vue?vue&type=style&index=0&id=b473ceac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports